import { VFC } from 'react';
import { Spin } from 'antd';
import { FullWidthHeightSpace } from './Space/FullWidthHeightSpace';

export const LoadingSpinner: VFC<{ message?: string }> = ({ message }) => (
  <FullWidthHeightSpace className="text-center">
    <Spin size="large" tip={message} />
  </FullWidthHeightSpace>
);
